<template>
  <div class="selectTime">
    <van-cell-group>
      <van-field label="开始时间" v-model="startTime" placeholder="请选择开始时间" readonly is-link @click="show=true,selType=1"/>
      <van-field label="结束时间" v-model="endTime" placeholder="请选择结束时间"  readonly is-link @click="show=true,selType=2" />
    </van-cell-group>
    <div class="btn" @click="back">确 定</div>
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="confirm"
      />
    </van-popup>
  </div>
</template>

<script>
import {longtimestampToDate} from "@/utils/timestamp"
export default {
  name: 'selectTime',
  data(){
    return {
      show:false,
      selType:1,
      startTime: "",
      endTime: "",
      minDate: new Date(2018, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
    }
  },
  created(){

  },
  mounted(){

  },
  methods:{
    confirm(value){
      this.selType == 1 ? this.startTime = longtimestampToDate(value) :  this.endTime = longtimestampToDate(value)
      this.show = false
    },
    back(){
      if(!this.startTime){this.$toast("请选择开始时间！"); return false }
      if(!this.endTime){this.$toast("请选择结束时间！"); return false }
      this.$route.meta.backData = JSON.stringify({s_time:this.startTime,e_time:this.endTime})
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
  .selectTime{
    .btn{
      width: 6.9rem;
      line-height: 0.72rem;
      background-color: #31b158;
      color: #fff;
      text-align: center;
      font-size: 0.32rem;
      margin: 0.6rem auto 0;
      border-radius: 0.08rem;
    }
  }
</style>